export default "__VITE_ASSET__BNJHuuTP__"